<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- LANGUAGE FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- INPUT COORDINATION-->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_coordination}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCoordination').value}}</span>
                    </div>

                    <!-- INPUT CURRENCIES -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('selectedCurrency').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_select}} {{translations.lbl_currency}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="currencies" formControlName="selectedCurrency"
                                placeholder="{{lbl_select}} {{lbl_currency}}" optionLabel="value" [showClear]="true"
                                [filter]="true" (onChange)="onChangeUserPreferences()"></p-dropdown>
                        </div>
                    </div>

                    <!-- INPUT PERIODS -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_select}} {{translations.lbl_period}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listPeriods" [options]="periods" formControlName="selectedPeriod"
                                placeholder="{{translations.lbl_select}} {{translations.lbl_period}}" optionLabel="descrip"
                                [filter]="true" (onChange)="reload()"></p-dropdown>
                        </div>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <br />
    <!-- TAB VIEW -->
    <p-tabView>

        <!-- TAB PANEL CXC -->
        <p-tabPanel [header]="'Cuentas por Cobrar'">
            <p-table emptyMessage="Registros no existentes" #dt1 [autoLayout]="true" [columns]="cols" [value]="dataI"
                [paginator]="true" [rows]="40" [showCurrentPageReport]="false" [globalFilterFields]="colsGlI"
                responsive="true">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel('receivable')"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"
                              ></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reload()"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" class="text-left"
                            [ngClass]="{'vertical-header': shouldApplyVerticalStyle(col), 'horizontal-header': !shouldApplyVerticalStyle(col), 'text-right': col.type == 'float'}"
                            [pTooltip]="col.header">
                            {{ col.header }}
                        </th>
                        <th [pTooltip]="translations.lbl_actions">
                            {{translations.lbl_actions}}
                        </th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-transaction let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns" [ngClass]="{
                            'text-right': isNumeric(transaction[col.field])
                        }">
                            <span class="p-column-title">{{col.header}}</span>
                            {{ getNestedValue(transaction, col.field) }}
                        </td>
                        <td>
                            <button *ngIf="transaction.currencyId != 'TOTAL'" pButton pRipple icon="pi pi-play"
                                class="p-button-rounded p-button-info p-mr-2"
                                (click)="redirectListFVDetailMater(transaction,'AR')"></button>
                        </td>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 9">
                            No se encontraron registros en la consulta solicitada.
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ translations.lbl_there_are }} {{ dataI?.length > 0 ? dataI?.length -1: 0 }} {{
                        translations.lbl_records }}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <!-- TAB PANEL CXP -->
        <p-tabPanel [header]="'Cuentas por Pagar'">
            <p-table emptyMessage="Registros no existentes" #dt2 [autoLayout]="true" [columns]="cols" [value]="dataO"
                [paginator]="true" [rows]="40" [showCurrentPageReport]="false" [globalFilterFields]="colsGlI"
                responsive="true">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel('payable')"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"
                                label=""></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reload()"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" class="text-left"
                             [ngClass]="{'vertical-header': shouldApplyVerticalStyle(col), 'horizontal-header': !shouldApplyVerticalStyle(col), 'text-right': col.type == 'float'}"
                            [pTooltip]="col.header">
                            {{ col.header }}
                        </th>
                        <th>
                            {{translations.lbl_actions}}
                        </th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-transaction let-columns="columns">
                     <tr>
                        <td *ngFor="let col of columns" [ngClass]="{
                            'text-right': isNumeric(transaction[col.field])
                        }">
                            <span class="p-column-title">{{col.header}}</span>
                            {{ getNestedValue(transaction, col.field) }}
                        </td>
                        <td>
                            <button *ngIf="transaction.currencyId != 'TOTAL'" pButton pRipple icon="pi pi-play"
                                class="p-button-rounded p-button-info p-mr-2"
                                (click)="redirectListFVDetailMater(transaction,'AP')"></button>
                        </td>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length +1 : 9">
                            No se encontraron registros en la consulta solicitada.
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ translations.lbl_there_are }} {{ dataO?.length > 0 ? dataO?.length -1: 0 }} {{
                        translations.lbl_records }}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</div>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>